import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../SDA/AuthService';
import './SessionTimeout.css';
import sessionBackground from '../../assets/images/Banner3.svg';

const SessionTimeout = () => {
    const navigate = useNavigate();

    const handleLogin = async () => {
        await AuthService.signinRedirect('/dashboard');
    };

    return (
        <div
            className="session-timeout-container"
            style={{
                backgroundImage: `linear-gradient(rgba(3, 26, 51, 0.82), rgba(3, 26, 51, 0.82)), url(${sessionBackground})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <h3 className="session-timeout-heading">Your session has expired</h3>
            <p className="session-timeout-text">
                Click here to <button className="session-timeout-button" onClick={handleLogin}>Login</button>
            </p>
            <p className="session-timeout-text">Copyright © IQVIA. All rights reserved</p>
        </div>
);
};

export default SessionTimeout;